import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Authentication APIs
export const chatLogin = (data) => api.create(url.LOGIN, data);
export const forgotPassword = data => api.create(url.PASSWORD_FORGET, data);
export const ResetPassword = data => api.create(url.RESET_PASSWORD, data);

// Profile APIs
export const editUser = (data) => api.put(`${url.EDIT_USER}`, data);
export const fetchProfile = (data) => api.get(url.FETCH_PROFILE, data);

// Dashboard APIs
export const dashboardCount = () => api.get(url.DASHBOARD_COUNT_URL);

// Users APIs
export const getAllUsers = (data) => api.get(url.GET_ALL_USERS, data);
export const updateAdminUser = (id, data) => api.put(`${url.GET_ALL_USERS}/${id}`, data);
export const updateAdminUserStatus = (id, data) => api.put(`${url.GET_ALL_USERS}/${id}/status`, data);
export const deleteAdminUser = (id) => api.delete(`${url.GET_ALL_USERS}/${id}`);
export const createAdminUser = (data) => api.create(url.GET_ALL_USERS, data);
export const bulkDeleteUsersApi = (data) => api.delete(url.BULK_DELETE_USERS, { data });

//news APIs
// news APIs - Change from multipart/form-data to JSON
export const getAllNews = (data) => api.get(url.GET_ALL_NEWS, data);
export const getNewsById = (id) => api.get(`${url.GET_ALL_NEWS}/${id}`);
export const createNews = (data) => api.create(url.GET_ALL_NEWS, data); // Remove multipart headers
export const updateNews = (id, data) => api.put(`${url.GET_ALL_NEWS}/${id}`, data); // Remove multipart headers
export const deleteNews = (id) => api.delete(`${url.GET_ALL_NEWS}/${id}`);
export const bulkDeleteNews = (newsIds) =>
  api.delete(url.BULK_DELETE_NEWS, {
    data: { newsIds },
  });

//posts APIs
/**
 * Get all posts with pagination and filtering
 * @param {Object} data - Query parameters
 * @param {number} data.page - Page number (default: 1)
 * @param {number} data.limit - Items per page (default: 10)
 * @param {string} data.search - Search query
 * @param {string} data.orderBy - Field to order by (default: "createdAt")
 * @param {string} data.order - Order direction "asc" or "desc" (default: "desc")
 * @returns {Promise<Object>} Response object
 * @returns {number} response.status - 1 for success, 0 for failure
 * @returns {string} response.message - Response message
 * @returns {Array<Object>} response.data - Array of post objects
 * @returns {string} response.data[].id - Post ID
 * @returns {string} response.data[].description - Post description
 * @returns {string} response.data[].mediaType - Media type (image/video)
 * @returns {string} response.data[].mediaUrl - Media URL
 * @returns {Object} response.data[].author - Author details
 * @returns {boolean} response.data[].messageRequestSent - Current user sent message request to post author
 * @returns {boolean} response.data[].messageRequestAccepted - Message request was accepted by author
 * @returns {number} response.currentUserPostCount - Total posts by logged-in user
 * @returns {number} response.totalData - Total number of posts
 * 
 * @requires Bearer token authentication
 */
export const getAllPosts = (data) => api.get(url.GET_ALL_POSTS, data);
export const getPostByIdService = (id) => api.get(`${url.GET_ALL_POSTS}/${id}`);
export const bulkDeletePosts = (postIds) =>
  api.delete(url.BULK_DELETE_POSTS, {
    data: { postIds }, // ✅ matches backend expectation
  });


// Policy APIs
export const createPolicy = (data) => api.create(url.POLICY_BASE, data); // auth
export const getLatestPolicy = (params) => api.get(url.POLICY_BASE, params); // open
export const getPolicyById = (id) => api.get(`${url.POLICY_BASE}/${id}`); // open
export const updatePolicyById = (id, data) => api.put(`${url.POLICY_BASE}/${id}`, data); // auth
export const deletePolicyById = (id) => api.delete(`${url.POLICY_BASE}/${id}`); // auth

// Terms APIs
export const createOrUpdateTerms = (data) => api.create(url.TERMS_BASE, data); // auth
export const getLatestTerms = (params) => api.get(url.TERMS_BASE, params); // open
export const getTermsById = (id) => api.get(`${url.TERMS_BASE}/${id}`); // open
export const updateTermsById = (id, data) => api.put(`${url.TERMS_BASE}/${id}`, data); // auth
export const deleteTermsById = (id) => api.delete(`${url.TERMS_BASE}/${id}`); // auth

//post
// In your api_helper/index.js for posts
export const createPostService = (data) => {
  return api.create(url.GET_ALL_POSTS, data);
};

export const updatePostService = (id, data) => {
  return api.put(`${url.GET_ALL_POSTS}/${id}`, data);
};
export const deletePostService = (id) => api.delete(`${url.GET_ALL_POSTS}/${id}`);

// Chats APIs
export const getAllGroupChats = (params = {}) => {
  const { search = '', type = 'group', page = 1, limit = 50 } = params;
  const queryParams = new URLSearchParams({ type });

  if (search) queryParams.append('search', search);
  queryParams.append('page', page.toString());
  queryParams.append('limit', limit.toString());

  return api.get(`${url.CHAT_REQUESTS}?${queryParams.toString()}`);
};

export const getChatById = (chatId, params = {}) => {
  const { page = 1, limit = 50 } = params;
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString()
  });

  return api.get(`${url.CHAT_BY_ID}/${chatId}?${queryParams.toString()}`);
};

export const createGroupChat = (data) => api.create(url.CREATE_GROUP_CHAT, data);

export const sendMessage = (chatId, payload) =>
  api.create(`${url.CHAT_BY_ID}/${chatId}/message`, payload);

// Upload media (image/video/audio/pdf) to chat
export const uploadChatMedia = (chatId, formData) =>
  api.create(`${url.CHAT_BY_ID}/${chatId}/media`, formData);

export const editChatMessage = (chatId, messageId, data) =>
  api.put(`${url.CHAT_BY_ID}/${chatId}/message/${messageId}`, data);



// Delete single or multiple messages (bulk delete supported)
export const deleteChatMessage = (chatId, payload) =>
  api.delete(`${url.DELETE_CHAT_MESSAGE}/${chatId}`, { data: payload });

// Contact APIs
// ✅ Must pass config as the second argument
export const getAllContacts = (config) => api.get(url.GET_ALL_CONTACTS, config);
export const getContactById = (id) => api.get(`${url.GET_CONTACT_BY_ID}/${id}`);

// File upload API
export const uploadFile = (data) =>
  api.create("api/upload", data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });

// subscription APIs
export const getAllSubscriptions = (params = {}) =>
  api.get(url.GET_ALL_SUBSCRIPTIONS, params);

export const getSubscriptionById = (id) => api.get(`${url.GET_SUBSCRIPTION_BY_ID}/${id}`);
export const getSubscriptionTransactions = (userId) =>
  api.get(`/api/subscription/admin/user/${userId}/transactions`);

//Notifictions
export const getNotifictions = (queryParams = "") => {
  return api.get(`${url.NOTFICATIONS}${queryParams}`);
};
export const getNotifictionsById = (id) => { return api.put(`${url.NOTFICATIONS}/${id}/read`); };

// Drawings History APIs
export const getDrawingsHistory = (data) => api.get(url.GET_DRAWINGS_HISTORY, data);